import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `HeaderButtonRoot`,
  button: `HeaderButtonButton`
};

export function useHeaderButtonStyles(buttonAreaWidth: string) {
  const width = buttonAreaWidth || `25%`;
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          textAlign: `left`,
          width
        }
      ],
      button: [
        classNames.button,
        {
          width: `max-content`
        }
      ]
    }),
    [width]
  );
}
